import { render, staticRenderFns } from "./cityLevelGoals.vue?vue&type=template&id=bbc898b6"
import script from "./cityLevelGoals.vue?vue&type=script&lang=js"
export * from "./cityLevelGoals.vue?vue&type=script&lang=js"
import style0 from "./cityLevelGoals.vue?vue&type=style&index=0&id=bbc898b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports